import { EnumTagSemanticoDTOAggregazione } from '@framework/api-client/api/users/schemas/enumTagSemanticoDTOAggregazione.ts';
import { type TagSemanticoDTO } from '@framework/api-client/api/users/schemas/tagSemanticoDTO.ts';

/** Modalità del valore di un tag semantico, derivata da flMultiplo + aggregazione. */
export enum SemanticTagMode {
  UNIQUE_SHARED = 'UNIQUE_SHARED',
  AGGREGATED = 'AGGREGATED',
  MULTIPLE = 'MULTIPLE',
}

/**
 * Traduce i campi flMultiplo e aggregazione dell'API nella modalità del tag.
 * Unica definizione della derivazione, condivisa da form admin, badge e
 * configurazione widget.
 */
export function deriveSemanticTagMode(
  flMultiplo: TagSemanticoDTO['flMultiplo'],
  aggregazione: TagSemanticoDTO['aggregazione'],
): SemanticTagMode | undefined {
  switch (true) {
    case Boolean(flMultiplo):
      return SemanticTagMode.MULTIPLE;
    case aggregazione === EnumTagSemanticoDTOAggregazione.UNIVOCA:
      return SemanticTagMode.UNIQUE_SHARED;
    case Boolean(aggregazione):
      return SemanticTagMode.AGGREGATED;
    default:
      return undefined;
  }
}
